import { Stack, StackProps } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { FC } from 'react';

export type DropZoneBlockProps = {
  error?: boolean;
  active?: boolean;
} & StackProps;

export const DropZoneBlock: FC<DropZoneBlockProps> = ({
  children,
  error,
  active,
  sx,
  ...props
}) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={(theme) => ({
        p: 2.5,
        borderRadius: theme.spacing(1),
        border: theme.mixins.borderControlValue(),
        outline: error || active ? theme.mixins.borderValue('2px') : undefined,
        outlineColor: error ? 'error.superLight' : 'common.lightBg',
        borderColor: error ? 'error.main' : undefined,
        bgcolor: active ? 'common.lightBg' : 'background.paper',
        cursor: 'pointer',
        color: active ? 'text.primary' : 'common.grey',
        '&:hover': {
          outline: theme.mixins.borderValue('2px'),
          outlineColor: error ? 'error.superLight' : 'common.lightBg',
          borderColor: error ? 'error.main' : undefined,
          bgcolor: 'common.lightBg',
          color: 'text.primary',
        },
        ...((typeof sx === 'function' ? sx(theme) : sx) as SystemStyleObject),
      })}
      {...props}
    >
      {children}
    </Stack>
  );
};
